var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWelcomeRealisticVoiceover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_632ad81e86a899d4170c2412_voice-brand-svgrepo-com",
    "data-name": "632ad81e86a899d4170c2412_voice-brand-svgrepo-com",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M20,0A20,20,0,1,0,40,20,20,20,0,0,0,20,0Zm0,38.66A18.66,18.66,0,1,1,38.66,20,18.66,18.66,0,0,1,20,38.66Z",
    fill: "#0e2444"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M20.773,2.706A18.067,18.067,0,1,0,38.84,20.773,18.067,18.067,0,0,0,20.773,2.706Zm0,34.632a16.414,16.414,0,0,1-8.338-2.278h11.2s-1.934-.947-2.153-1.755c-.651-2.4.531-5.137,1.937-4.874,1.828.339,5.393,3.067,5.77-.275.222-1.952.838-1.451,1.016-1.87.262-.622-2.481-1.177-2.756-1.344.222-.075,3.281-.757,3.3-1.32.274-.414-.917-1.077-.789-1.593.251-1.024,1.433-.683,1.916-1.318.64-.854-.494-1.59-1.054-2.1-.841-.755-1.987-1.515-1.673-3.132.2-1.136-.15-2.459.19-2.9a5.21,5.21,0,0,0-.809-5.226c-2.265-2.72-1.635,1.891-4.465.514C20.426,6.1,14.4,5.95,10.89,10.1c-2.214,2.622-1.489,9.144-.171,12.71.474,1.28,1.723,1.868,1.825,3.59a12.712,12.712,0,0,1-1.278,7.919,16.541,16.541,0,1,1,9.507,3.022Z",
    transform: "translate(-0.84 -0.84)",
    fill: "#0e2444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcomeRealisticVoiceover);
export default __webpack_public_path__ + "static/media/welcome-realistic-voiceover.5e8cf83e38d869dcd40c535b33739c4c.svg";
export { ForwardRef as ReactComponent };